export const EXPLAIN_FORECAST_DISABLED_MESSAGE =
  "Explaining demand is coming soon to the new demand module."

export function buildExplainForecastPrompt(variantId: string): string {
  return `Explain the forecast for variant ${variantId}. Keep the explanation concise and jargon-free, at most 3-4 short sentences highlighting the key drivers. No headings.`
}

const EXPLAIN_FORECAST_SHAPE =
  /^Explain the forecast for variant .+\. Keep the explanation concise/i

export function isGeneratedPrompt(content: string): boolean {
  return EXPLAIN_FORECAST_SHAPE.test(content.trim())
}
